module.exports = __webpack_public_path__ + "img/blog-single.39e617be.jpg";